import { getContext } from '@/context';
import getPublicHeaders from '@/requests/common/getPublicHeaders';

interface FetchLibraryDataParams<T> {
  url: string;
  signal?: AbortSignal;
  transform: (data: unknown) => T | null;
}

/**
 * CMS fetch with a transform step. The CMS lives outside the SDK's auth
 * middleware — getPublicHeaders() strips Authorization. Errors are swallowed
 * to null so existing callers stay backwards-compatible.
 */
export const fetchLibraryData = async <T>({
  url,
  signal,
  transform,
}: FetchLibraryDataParams<T>): Promise<T | null> => {
  try {
    const response = await getContext().utils.api.fetch(url, {
      headers: getPublicHeaders(),
      signal,
    });
    if (!response.ok) return null;
    const data: unknown = await response.json();
    return transform(data);
  } catch {
    return null;
  }
};
